import Text from 'components/_core/Text';

import { locales } from './locales';
import { APPLICATION_FOLLOW_UP_STEPS } from './statuses';
import { ApplicationStep, ApplicationStepCardBody } from './types';

const ApplicationVerificationBody: ApplicationStepCardBody = () => {
  return <Text>{locales.applicationVerification.body}</Text>;
};

export const applicationVerificationStep = {
  activeBadgeLabel: locales.activeBadgeLabel.ongoing,

  body: ApplicationVerificationBody,

  isActive: ({ capitalDeposit }) =>
    APPLICATION_FOLLOW_UP_STEPS[capitalDeposit.status] === 'verification',

  title: locales.applicationVerification.title,
} satisfies ApplicationStep;
